import { alpacaDebtTokens, miMATIC } from '@jdiyield/constants'
import { Position } from '@jdiyield/interfaces'
import Web3 from 'web3'

import { getAlpacaPositions } from './platforms/alpaca'
import { getMaiPositions } from './platforms/maiFinance'
import getNodeUrl from './rpcRandom'

export const queryPositions = async (
  contract: string,
  latestPosition: number,
  web3Prop?: Record<number, Web3>
): Promise<Position[]> => {
  if (alpacaDebtTokens.includes(contract)) {
    const web3 = web3Prop?.[56] || new Web3(getNodeUrl(56))
    return await getAlpacaPositions(web3, contract, latestPosition)
  }
  if (contract === miMATIC) {
    const web3 = web3Prop?.[137] || new Web3(getNodeUrl(137))
    return await getMaiPositions(web3, latestPosition)
  }

  return []
}
